import { warn as h, nextTick as Ht, createVNode as bt, defineComponent as Kt, createRenderer as Ft, getCurrentInstance as St, h as Wt, BaseTransition as Ut, assertNumber as Gt, BaseTransitionPropsValidators as zt, useTransitionState as qt, onUpdated as Xt, Fragment as Zt, getTransitionRawChildren as Jt, setTransitionHooks as Y, resolveTransitionHooks as k, Text as Qt, callWithAsyncErrorHandling as Yt } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { Comment as ln, Static as fn, Teleport as pn, callWithErrorHandling as un, cloneVNode as dn, computed as hn, createBlock as mn, createCommentVNode as _n, createElementBlock as vn, createElementVNode as gn, createTextVNode as Cn, guardReactiveProps as En, handleError as bn, initCustomFormatter as Sn, inject as yn, isRuntimeOnly as Nn, isVNode as wn, mergeProps as Tn, onActivated as An, onBeforeMount as On, onBeforeUnmount as Rn, onBeforeUpdate as Pn, onDeactivated as Dn, onErrorCaptured as Mn, onMounted as Vn, onRenderTracked as Ln, onRenderTriggered as xn, onServerPrefetch as $n, onUnmounted as In, openBlock as jn, provide as Bn, queuePostFlushCb as Hn, renderList as Kn, renderSlot as Fn, resolveComponent as Wn, resolveDirective as Un, resolveDynamicComponent as Gn, setBlockTracking as zn, ssrContextKey as qn, useSSRContext as Xn, useTemplateRef as Zn, version as Jn, watch as Qn, watchEffect as Yn, withCtx as kn, withDirectives as ts } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { isPlainObject as yt, extend as y, hasOwn as kt, camelize as P, hyphenate as E, isFunction as W, isHTMLTag as te, isSVGTag as ee, isMathMLTag as ne, isString as D, isArray as N, toNumber as H, isObject as se, isOn as oe, isModelListener as ie, capitalize as re, includeBooleanAttr as Nt, isSymbol as ce, isSpecialBooleanAttr as ae, NOOP as le } from "../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import { normalizeClass as ns, normalizeStyle as ss, toDisplayString as os, toHandlerKey as is } from "../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import { unref as fe, toRaw as pe } from "../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { EffectScope as cs, ReactiveEffect as as, effectScope as ls, getCurrentScope as fs, isProxy as ps, isReactive as us, isReadonly as ds, isRef as hs, isShallow as ms, markRaw as _s, onWatcherCleanup as vs, proxyRefs as gs, reactive as Cs, readonly as Es, ref as bs, shallowReactive as Ss, shallowReadonly as ys, shallowRef as Ns, toRef as ws } from "../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
/**
* @vue/runtime-dom v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let K;
const tt = typeof window != "undefined" && window.trustedTypes;
if (tt)
  try {
    K = /* @__PURE__ */ tt.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && h(`Error creating trusted types policy: ${e}`);
  }
const wt = K ? (e) => K.createHTML(e) : (e) => e, ue = "http://www.w3.org/2000/svg", de = "http://www.w3.org/1998/Math/MathML", v = typeof document != "undefined" ? document : null, et = v && /* @__PURE__ */ v.createElement("template"), he = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, s) => {
    const o = t === "svg" ? v.createElementNS(ue, e) : t === "mathml" ? v.createElementNS(de, e) : n ? v.createElement(e, { is: n }) : v.createElement(e);
    return e === "select" && s && s.multiple != null && o.setAttribute("multiple", s.multiple), o;
  },
  createText: (e) => v.createTextNode(e),
  createComment: (e) => v.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => v.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, s, o, i) {
    const r = n ? n.previousSibling : t.lastChild;
    if (o && (o === i || o.nextSibling))
      for (; t.insertBefore(o.cloneNode(!0), n), !(o === i || !(o = o.nextSibling)); )
        ;
    else {
      et.innerHTML = wt(
        s === "svg" ? `<svg>${e}</svg>` : s === "mathml" ? `<math>${e}</math>` : e
      );
      const c = et.content;
      if (s === "svg" || s === "mathml") {
        const l = c.firstChild;
        for (; l.firstChild; )
          c.appendChild(l.firstChild);
        c.removeChild(l);
      }
      t.insertBefore(c, n);
    }
    return [
      // first
      r ? r.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, g = "transition", O = "animation", A = Symbol("_vtc"), Tt = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, At = /* @__PURE__ */ y(
  {},
  zt,
  Tt
), me = (e) => (e.displayName = "Transition", e.props = At, e), tn = /* @__PURE__ */ me(
  (e, { slots: t }) => Wt(Ut, Ot(e), t)
), S = (e, t = []) => {
  N(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, nt = (e) => e ? N(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function Ot(e) {
  const t = {};
  for (const a in e)
    a in Tt || (t[a] = e[a]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: s,
    duration: o,
    enterFromClass: i = `${n}-enter-from`,
    enterActiveClass: r = `${n}-enter-active`,
    enterToClass: c = `${n}-enter-to`,
    appearFromClass: l = i,
    appearActiveClass: f = r,
    appearToClass: p = c,
    leaveFromClass: u = `${n}-leave-from`,
    leaveActiveClass: d = `${n}-leave-active`,
    leaveToClass: w = `${n}-leave-to`
  } = e, T = _e(o), Lt = T && T[0], xt = T && T[1], {
    onBeforeEnter: G,
    onEnter: z,
    onEnterCancelled: q,
    onLeave: X,
    onLeaveCancelled: $t,
    onBeforeAppear: It = G,
    onAppear: jt = z,
    onAppearCancelled: Bt = q
  } = t, $ = (a, m, b, M) => {
    a._enterCancelled = M, C(a, m ? p : c), C(a, m ? f : r), b && b();
  }, Z = (a, m) => {
    a._isLeaving = !1, C(a, u), C(a, w), C(a, d), m && m();
  }, J = (a) => (m, b) => {
    const M = a ? jt : z, Q = () => $(m, a, b);
    S(M, [m, Q]), st(() => {
      C(m, a ? l : i), _(m, a ? p : c), nt(M) || ot(m, s, Lt, Q);
    });
  };
  return y(t, {
    onBeforeEnter(a) {
      S(G, [a]), _(a, i), _(a, r);
    },
    onBeforeAppear(a) {
      S(It, [a]), _(a, l), _(a, f);
    },
    onEnter: J(!1),
    onAppear: J(!0),
    onLeave(a, m) {
      a._isLeaving = !0;
      const b = () => Z(a, m);
      _(a, u), a._enterCancelled ? (_(a, d), F()) : (F(), _(a, d)), st(() => {
        a._isLeaving && (C(a, u), _(a, w), nt(X) || ot(a, s, xt, b));
      }), S(X, [a, b]);
    },
    onEnterCancelled(a) {
      $(a, !1, void 0, !0), S(q, [a]);
    },
    onAppearCancelled(a) {
      $(a, !0, void 0, !0), S(Bt, [a]);
    },
    onLeaveCancelled(a) {
      Z(a), S($t, [a]);
    }
  });
}
function _e(e) {
  if (e == null)
    return null;
  if (se(e))
    return [I(e.enter), I(e.leave)];
  {
    const t = I(e);
    return [t, t];
  }
}
function I(e) {
  const t = H(e);
  return process.env.NODE_ENV !== "production" && Gt(t, "<transition> explicit duration"), t;
}
function _(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[A] || (e[A] = /* @__PURE__ */ new Set())).add(t);
}
function C(e, t) {
  t.split(/\s+/).forEach((s) => s && e.classList.remove(s));
  const n = e[A];
  n && (n.delete(t), n.size || (e[A] = void 0));
}
function st(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let ve = 0;
function ot(e, t, n, s) {
  const o = e._endId = ++ve, i = () => {
    o === e._endId && s();
  };
  if (n != null)
    return setTimeout(i, n);
  const { type: r, timeout: c, propCount: l } = Rt(e, t);
  if (!r)
    return s();
  const f = r + "end";
  let p = 0;
  const u = () => {
    e.removeEventListener(f, d), i();
  }, d = (w) => {
    w.target === e && ++p >= l && u();
  };
  setTimeout(() => {
    p < l && u();
  }, c + 1), e.addEventListener(f, d);
}
function Rt(e, t) {
  const n = window.getComputedStyle(e), s = (T) => (n[T] || "").split(", "), o = s(`${g}Delay`), i = s(`${g}Duration`), r = it(o, i), c = s(`${O}Delay`), l = s(`${O}Duration`), f = it(c, l);
  let p = null, u = 0, d = 0;
  t === g ? r > 0 && (p = g, u = r, d = i.length) : t === O ? f > 0 && (p = O, u = f, d = l.length) : (u = Math.max(r, f), p = u > 0 ? r > f ? g : O : null, d = p ? p === g ? i.length : l.length : 0);
  const w = p === g && /\b(transform|all)(,|$)/.test(
    s(`${g}Property`).toString()
  );
  return {
    type: p,
    timeout: u,
    propCount: d,
    hasTransform: w
  };
}
function it(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, s) => rt(n) + rt(e[s])));
}
function rt(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function F() {
  return document.body.offsetHeight;
}
function ge(e, t, n) {
  const s = e[A];
  s && (t = (t ? [t, ...s] : [...s]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const L = Symbol("_vod"), Pt = Symbol("_vsh"), Ce = {
  beforeMount(e, { value: t }, { transition: n }) {
    e[L] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : R(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: s }) {
    !t != !n && (s ? t ? (s.beforeEnter(e), R(e, !0), s.enter(e)) : s.leave(e, () => {
      R(e, !1);
    }) : R(e, t));
  },
  beforeUnmount(e, { value: t }) {
    R(e, t);
  }
};
process.env.NODE_ENV !== "production" && (Ce.name = "show");
function R(e, t) {
  e.style.display = t ? e[L] : "none", e[Pt] = !t;
}
const Ee = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), be = /(^|;)\s*display\s*:/;
function Se(e, t, n) {
  const s = e.style, o = D(n);
  let i = !1;
  if (n && !o) {
    if (t)
      if (D(t))
        for (const r of t.split(";")) {
          const c = r.slice(0, r.indexOf(":")).trim();
          n[c] == null && V(s, c, "");
        }
      else
        for (const r in t)
          n[r] == null && V(s, r, "");
    for (const r in n)
      r === "display" && (i = !0), V(s, r, n[r]);
  } else if (o) {
    if (t !== n) {
      const r = s[Ee];
      r && (n += ";" + r), s.cssText = n, i = be.test(n);
    }
  } else
    t && e.removeAttribute("style");
  L in e && (e[L] = i ? s.display : "", e[Pt] && (s.display = "none"));
}
const ye = /[^\\];\s*$/, ct = /\s*!important$/;
function V(e, t, n) {
  if (N(n))
    n.forEach((s) => V(e, t, s));
  else if (n == null && (n = ""), process.env.NODE_ENV !== "production" && ye.test(n) && h(
    `Unexpected semicolon at the end of '${t}' style value: '${n}'`
  ), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const s = Ne(e, t);
    ct.test(n) ? e.setProperty(
      E(s),
      n.replace(ct, ""),
      "important"
    ) : e[s] = n;
  }
}
const at = ["Webkit", "Moz", "ms"], j = {};
function Ne(e, t) {
  const n = j[t];
  if (n)
    return n;
  let s = P(t);
  if (s !== "filter" && s in e)
    return j[t] = s;
  s = re(s);
  for (let o = 0; o < at.length; o++) {
    const i = at[o] + s;
    if (i in e)
      return j[t] = i;
  }
  return t;
}
const lt = "http://www.w3.org/1999/xlink";
function ft(e, t, n, s, o, i = ae(t)) {
  s && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(lt, t.slice(6, t.length)) : e.setAttributeNS(lt, t, n) : n == null || i && !Nt(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    i ? "" : ce(n) ? String(n) : n
  );
}
function pt(e, t, n, s, o) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? wt(n) : n);
    return;
  }
  const i = e.tagName;
  if (t === "value" && i !== "PROGRESS" && // custom elements may use _value internally
  !i.includes("-")) {
    const c = i === "OPTION" ? e.getAttribute("value") || "" : e.value, l = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (c !== l || !("_value" in e)) && (e.value = l), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let r = !1;
  if (n === "" || n == null) {
    const c = typeof e[t];
    c === "boolean" ? n = Nt(n) : n == null && c === "string" ? (n = "", r = !0) : c === "number" && (n = 0, r = !0);
  }
  try {
    e[t] = n;
  } catch (c) {
    process.env.NODE_ENV !== "production" && !r && h(
      `Failed setting prop "${t}" on <${i.toLowerCase()}>: value ${n} is invalid.`,
      c
    );
  }
  r && e.removeAttribute(o || t);
}
function we(e, t, n, s) {
  e.addEventListener(t, n, s);
}
function Te(e, t, n, s) {
  e.removeEventListener(t, n, s);
}
const ut = Symbol("_vei");
function Ae(e, t, n, s, o = null) {
  const i = e[ut] || (e[ut] = {}), r = i[t];
  if (s && r)
    r.value = process.env.NODE_ENV !== "production" ? ht(s, t) : s;
  else {
    const [c, l] = Oe(t);
    if (s) {
      const f = i[t] = De(
        process.env.NODE_ENV !== "production" ? ht(s, t) : s,
        o
      );
      we(e, c, f, l);
    } else
      r && (Te(e, c, r, l), i[t] = void 0);
  }
}
const dt = /(?:Once|Passive|Capture)$/;
function Oe(e) {
  let t;
  if (dt.test(e)) {
    t = {};
    let s;
    for (; s = e.match(dt); )
      e = e.slice(0, e.length - s[0].length), t[s[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : E(e.slice(2)), t];
}
let B = 0;
const Re = /* @__PURE__ */ Promise.resolve(), Pe = () => B || (Re.then(() => B = 0), B = Date.now());
function De(e, t) {
  const n = (s) => {
    if (!s._vts)
      s._vts = Date.now();
    else if (s._vts <= n.attached)
      return;
    Yt(
      Me(s, n.value),
      t,
      5,
      [s]
    );
  };
  return n.value = e, n.attached = Pe(), n;
}
function ht(e, t) {
  return W(e) || N(e) ? e : (h(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), le);
}
function Me(e, t) {
  if (N(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (s) => (o) => !o._stopped && s && s(o)
    );
  } else
    return t;
}
const mt = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Ve = (e, t, n, s, o, i) => {
  const r = o === "svg";
  t === "class" ? ge(e, s, r) : t === "style" ? Se(e, n, s) : oe(t) ? ie(t) || Ae(e, t, n, s, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Le(e, t, s, r)) ? (pt(e, t, s), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && ft(e, t, s, r, i, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !D(s)) ? pt(e, P(t), s, i, t) : (t === "true-value" ? e._trueValue = s : t === "false-value" && (e._falseValue = s), ft(e, t, s, r));
};
function Le(e, t, n, s) {
  if (s)
    return !!(t === "innerHTML" || t === "textContent" || t in e && mt(t) && W(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const o = e.tagName;
    if (o === "IMG" || o === "VIDEO" || o === "CANVAS" || o === "SOURCE")
      return !1;
  }
  return mt(t) && D(n) ? !1 : t in e;
}
const _t = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function en(e, t, n) {
  const s = Kt(e, t);
  yt(s) && y(s, t);
  class o extends U {
    constructor(r) {
      super(s, r, n);
    }
  }
  return o.def = s, o;
}
const xe = typeof HTMLElement != "undefined" ? HTMLElement : class {
};
class U extends xe {
  constructor(t, n = {}, s = Et) {
    super(), this._def = t, this._props = n, this._createApp = s, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && s !== Et ? this._root = this.shadowRoot : (process.env.NODE_ENV !== "production" && this.shadowRoot && h(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this);
  }
  connectedCallback() {
    if (!this.isConnected)
      return;
    !this.shadowRoot && !this._resolved && this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof U) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? this._mount(this._def) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._inheritParentContext(t));
  }
  _inheritParentContext(t = this._parent) {
    t && this._app && Object.setPrototypeOf(
      this._app._context.provides,
      t._instance.provides
    );
  }
  disconnectedCallback() {
    this._connected = !1, Ht(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let s = 0; s < this.attributes.length; s++)
      this._setAttr(this.attributes[s].name);
    this._ob = new MutationObserver((s) => {
      for (const o of s)
        this._setAttr(o.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (s, o = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: i, styles: r } = s;
      let c;
      if (i && !N(i))
        for (const l in i) {
          const f = i[l];
          (f === Number || f && f.type === Number) && (l in this._props && (this._props[l] = H(this._props[l])), (c || (c = /* @__PURE__ */ Object.create(null)))[P(l)] = !0);
        }
      this._numberProps = c, this._resolveProps(s), this.shadowRoot ? this._applyStyles(r) : process.env.NODE_ENV !== "production" && r && h(
        "Custom element style injection is not supported when using shadowRoot: false"
      ), this._mount(s);
    }, n = this._def.__asyncLoader;
    n ? this._pendingResolve = n().then((s) => {
      s.configureApp = this._def.configureApp, t(this._def = s, !0);
    }) : t(this._def);
  }
  _mount(t) {
    process.env.NODE_ENV !== "production" && !t.name && (t.name = "VueElement"), this._app = this._createApp(t), this._inheritParentContext(), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const n = this._instance && this._instance.exposed;
    if (n)
      for (const s in n)
        kt(this, s) ? process.env.NODE_ENV !== "production" && h(`Exposed property "${s}" already exists on custom element.`) : Object.defineProperty(this, s, {
          // unwrap ref to be consistent with public instance behavior
          get: () => fe(n[s])
        });
  }
  _resolveProps(t) {
    const { props: n } = t, s = N(n) ? n : Object.keys(n || {});
    for (const o of Object.keys(this))
      o[0] !== "_" && s.includes(o) && this._setProp(o, this[o]);
    for (const o of s.map(P))
      Object.defineProperty(this, o, {
        get() {
          return this._getProp(o);
        },
        set(i) {
          this._setProp(o, i, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-"))
      return;
    const n = this.hasAttribute(t);
    let s = n ? this.getAttribute(t) : _t;
    const o = P(t);
    n && this._numberProps && this._numberProps[o] && (s = H(s)), this._setProp(o, s, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, s = !0, o = !1) {
    if (n !== this._props[t] && (n === _t ? delete this._props[t] : (this._props[t] = n, t === "key" && this._app && (this._app._ceVNode.key = n)), o && this._instance && this._update(), s)) {
      const i = this._ob;
      i && i.disconnect(), n === !0 ? this.setAttribute(E(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(E(t), n + "") : n || this.removeAttribute(E(t)), i && i.observe(this, { attributes: !0 });
    }
  }
  _update() {
    const t = this._createVNode();
    this._app && (t.appContext = this._app._context), ze(t, this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const n = bt(this._def, y(t, this._props));
    return this._instance || (n.ce = (s) => {
      this._instance = s, s.ce = this, s.isCE = !0, process.env.NODE_ENV !== "production" && (s.ceReload = (i) => {
        this._styles && (this._styles.forEach((r) => this._root.removeChild(r)), this._styles.length = 0), this._applyStyles(i), this._instance = null, this._update();
      });
      const o = (i, r) => {
        this.dispatchEvent(
          new CustomEvent(
            i,
            yt(r[0]) ? y({ detail: r }, r[0]) : { detail: r }
          )
        );
      };
      s.emit = (i, ...r) => {
        o(i, r), E(i) !== i && o(E(i), r);
      }, this._setParent();
    }), n;
  }
  _applyStyles(t, n) {
    if (!t)
      return;
    if (n) {
      if (n === this._def || this._styleChildren.has(n))
        return;
      this._styleChildren.add(n);
    }
    const s = this._nonce;
    for (let o = t.length - 1; o >= 0; o--) {
      const i = document.createElement("style");
      if (s && i.setAttribute("nonce", s), i.textContent = t[o], this.shadowRoot.prepend(i), process.env.NODE_ENV !== "production")
        if (n) {
          if (n.__hmrId) {
            this._childStyles || (this._childStyles = /* @__PURE__ */ new Map());
            let r = this._childStyles.get(n.__hmrId);
            r || this._childStyles.set(n.__hmrId, r = []), r.push(i);
          }
        } else
          (this._styles || (this._styles = [])).push(i);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let n;
    for (; n = this.firstChild; ) {
      const s = n.nodeType === 1 && n.getAttribute("slot") || "default";
      (t[s] || (t[s] = [])).push(n), this.removeChild(n);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), n = this._instance.type.__scopeId;
    for (let s = 0; s < t.length; s++) {
      const o = t[s], i = o.getAttribute("name") || "default", r = this._slots[i], c = o.parentNode;
      if (r)
        for (const l of r) {
          if (n && l.nodeType === 1) {
            const f = n + "-s", p = document.createTreeWalker(l, 1);
            l.setAttribute(f, "");
            let u;
            for (; u = p.nextNode(); )
              u.setAttribute(f, "");
          }
          c.insertBefore(l, o);
        }
      else
        for (; o.firstChild; )
          c.insertBefore(o.firstChild, o);
      c.removeChild(o);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
    if (process.env.NODE_ENV !== "production" && (this._styleChildren.delete(t), this._childStyles && t.__hmrId)) {
      const n = this._childStyles.get(t.__hmrId);
      n && (n.forEach((s) => this._root.removeChild(s)), n.length = 0);
    }
  }
}
function vt(e) {
  const t = St(), n = t && t.ce;
  return n || (process.env.NODE_ENV !== "production" && (t ? h(
    `${e || "useHost"} can only be used in components defined via defineCustomElement.`
  ) : h(
    `${e || "useHost"} called without an active component instance.`
  )), null);
}
function nn() {
  const e = process.env.NODE_ENV !== "production" ? vt("useShadowRoot") : vt();
  return e && e.shadowRoot;
}
const Dt = /* @__PURE__ */ new WeakMap(), Mt = /* @__PURE__ */ new WeakMap(), x = Symbol("_moveCb"), gt = Symbol("_enterCb"), $e = (e) => (delete e.props.mode, e), Ie = /* @__PURE__ */ $e({
  name: "TransitionGroup",
  props: /* @__PURE__ */ y({}, At, {
    tag: String,
    moveClass: String
  }),
  setup(e, { slots: t }) {
    const n = St(), s = qt();
    let o, i;
    return Xt(() => {
      if (!o.length)
        return;
      const r = e.moveClass || `${e.name || "v"}-move`;
      if (!Ke(
        o[0].el,
        n.vnode.el,
        r
      )) {
        o = [];
        return;
      }
      o.forEach(je), o.forEach(Be);
      const c = o.filter(He);
      F(), c.forEach((l) => {
        const f = l.el, p = f.style;
        _(f, r), p.transform = p.webkitTransform = p.transitionDuration = "";
        const u = f[x] = (d) => {
          d && d.target !== f || (!d || /transform$/.test(d.propertyName)) && (f.removeEventListener("transitionend", u), f[x] = null, C(f, r));
        };
        f.addEventListener("transitionend", u);
      }), o = [];
    }), () => {
      const r = pe(e), c = Ot(r);
      let l = r.tag || Zt;
      if (o = [], i)
        for (let f = 0; f < i.length; f++) {
          const p = i[f];
          p.el && p.el instanceof Element && (o.push(p), Y(
            p,
            k(
              p,
              c,
              s,
              n
            )
          ), Dt.set(
            p,
            p.el.getBoundingClientRect()
          ));
        }
      i = t.default ? Jt(t.default()) : [];
      for (let f = 0; f < i.length; f++) {
        const p = i[f];
        p.key != null ? Y(
          p,
          k(p, c, s, n)
        ) : process.env.NODE_ENV !== "production" && p.type !== Qt && h("<TransitionGroup> children must be keyed.");
      }
      return bt(l, null, i);
    };
  }
}), sn = Ie;
function je(e) {
  const t = e.el;
  t[x] && t[x](), t[gt] && t[gt]();
}
function Be(e) {
  Mt.set(e, e.el.getBoundingClientRect());
}
function He(e) {
  const t = Dt.get(e), n = Mt.get(e), s = t.left - n.left, o = t.top - n.top;
  if (s || o) {
    const i = e.el.style;
    return i.transform = i.webkitTransform = `translate(${s}px,${o}px)`, i.transitionDuration = "0s", e;
  }
}
function Ke(e, t, n) {
  const s = e.cloneNode(), o = e[A];
  o && o.forEach((c) => {
    c.split(/\s+/).forEach((l) => l && s.classList.remove(l));
  }), n.split(/\s+/).forEach((c) => c && s.classList.add(c)), s.style.display = "none";
  const i = t.nodeType === 1 ? t : t.parentNode;
  i.appendChild(s);
  const { hasTransform: r } = Rt(s);
  return i.removeChild(s), r;
}
const Fe = ["ctrl", "shift", "alt", "meta"], We = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => Fe.some((n) => e[`${n}Key`] && !t.includes(n))
}, on = (e, t) => {
  const n = e._withMods || (e._withMods = {}), s = t.join(".");
  return n[s] || (n[s] = (o, ...i) => {
    for (let r = 0; r < t.length; r++) {
      const c = We[t[r]];
      if (c && c(o, t))
        return;
    }
    return e(o, ...i);
  });
}, Ue = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, rn = (e, t) => {
  const n = e._withKeys || (e._withKeys = {}), s = t.join(".");
  return n[s] || (n[s] = (o) => {
    if (!("key" in o))
      return;
    const i = E(o.key);
    if (t.some(
      (r) => r === i || Ue[r] === i
    ))
      return e(o);
  });
}, Ge = /* @__PURE__ */ y({ patchProp: Ve }, he);
let Ct;
function Vt() {
  return Ct || (Ct = Ft(Ge));
}
const ze = (...e) => {
  Vt().render(...e);
}, Et = (...e) => {
  const t = Vt().createApp(...e);
  process.env.NODE_ENV !== "production" && (Xe(t), Ze(t));
  const { mount: n } = t;
  return t.mount = (s) => {
    const o = Je(s);
    if (!o)
      return;
    const i = t._component;
    !W(i) && !i.render && !i.template && (i.template = o.innerHTML), o.nodeType === 1 && (o.textContent = "");
    const r = n(o, !1, qe(o));
    return o instanceof Element && (o.removeAttribute("v-cloak"), o.setAttribute("data-v-app", "")), r;
  }, t;
};
function qe(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function Xe(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => te(t) || ee(t) || ne(t),
    writable: !1
  });
}
function Ze(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        h(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const n = e.config.compilerOptions, s = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return h(s), n;
      },
      set() {
        h(s);
      }
    });
  }
}
function Je(e) {
  if (D(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && h(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && h(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
export {
  Ut as BaseTransition,
  zt as BaseTransitionPropsValidators,
  ln as Comment,
  cs as EffectScope,
  Zt as Fragment,
  as as ReactiveEffect,
  fn as Static,
  pn as Teleport,
  Qt as Text,
  tn as Transition,
  sn as TransitionGroup,
  U as VueElement,
  Gt as assertNumber,
  Yt as callWithAsyncErrorHandling,
  un as callWithErrorHandling,
  P as camelize,
  re as capitalize,
  dn as cloneVNode,
  hn as computed,
  Et as createApp,
  mn as createBlock,
  _n as createCommentVNode,
  vn as createElementBlock,
  gn as createElementVNode,
  Ft as createRenderer,
  Cn as createTextVNode,
  bt as createVNode,
  Kt as defineComponent,
  en as defineCustomElement,
  ls as effectScope,
  St as getCurrentInstance,
  fs as getCurrentScope,
  Jt as getTransitionRawChildren,
  En as guardReactiveProps,
  Wt as h,
  bn as handleError,
  Sn as initCustomFormatter,
  yn as inject,
  ps as isProxy,
  us as isReactive,
  ds as isReadonly,
  hs as isRef,
  Nn as isRuntimeOnly,
  ms as isShallow,
  wn as isVNode,
  _s as markRaw,
  Tn as mergeProps,
  Ht as nextTick,
  ns as normalizeClass,
  ss as normalizeStyle,
  An as onActivated,
  On as onBeforeMount,
  Rn as onBeforeUnmount,
  Pn as onBeforeUpdate,
  Dn as onDeactivated,
  Mn as onErrorCaptured,
  Vn as onMounted,
  Ln as onRenderTracked,
  xn as onRenderTriggered,
  $n as onServerPrefetch,
  In as onUnmounted,
  Xt as onUpdated,
  vs as onWatcherCleanup,
  jn as openBlock,
  Bn as provide,
  gs as proxyRefs,
  Hn as queuePostFlushCb,
  Cs as reactive,
  Es as readonly,
  bs as ref,
  ze as render,
  Kn as renderList,
  Fn as renderSlot,
  Wn as resolveComponent,
  Un as resolveDirective,
  Gn as resolveDynamicComponent,
  k as resolveTransitionHooks,
  zn as setBlockTracking,
  Y as setTransitionHooks,
  Ss as shallowReactive,
  ys as shallowReadonly,
  Ns as shallowRef,
  qn as ssrContextKey,
  os as toDisplayString,
  is as toHandlerKey,
  pe as toRaw,
  ws as toRef,
  fe as unref,
  vt as useHost,
  Xn as useSSRContext,
  nn as useShadowRoot,
  Zn as useTemplateRef,
  qt as useTransitionState,
  Ce as vShow,
  Jn as version,
  h as warn,
  Qn as watch,
  Yn as watchEffect,
  kn as withCtx,
  ts as withDirectives,
  rn as withKeys,
  on as withModifiers
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_runtime-dom@3.5.18/~/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
// module id = 10
// module chunks = 67